import { useEffect, useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const Discounts = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/discounts").then((r) => setItems(r.data));
  }, []);
  const copy = (code) => {
    navigator.clipboard?.writeText(code);
    toast.success("Code copied. May it bless your exchange.");
  };
  return (
    <div data-testid="members-discounts">
      <span className="eyebrow">Ambassador Discounts</span>
      <h1 className="font-serif-h font-light text-4xl sm:text-5xl text-[#577731] mt-4">Savings on clinic services, classes, and products</h1>
      <div className="grid sm:grid-cols-2 gap-6 mt-12">
        {items.map((d) => (
          <article key={d.id} data-testid={`discount-${d.id}`} className="card-soft p-8 border-dashed">
            <h2 className="font-serif-h text-2xl">{d.title}</h2>
            <p className="text-sm text-[#232b1b]/70 mt-3">{d.details}</p>
            <button onClick={() => copy(d.code)} data-testid={`discount-copy-${d.id}`} className="mt-6 inline-flex items-center gap-3 rounded-full bg-[#b6689a]/10 px-5 py-2.5 font-mono text-sm text-[#b6689a] hover:bg-[#b6689a]/20 transition-colors">
              {d.code} <Copy size={14} />
            </button>
          </article>
        ))}
      </div>
      <a href="https://thehealersmarket.shop" target="_blank" rel="noreferrer" data-testid="discounts-market-btn" className="btn btn-mauve mt-10">Claim Your Candles at TheHealersMarket.shop</a>
    </div>
  );
};
